import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function CreditCardIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M17.4999 3.33301H2.49992c-.92048 0-1.666668.74619-1.666668 1.66666V14.9997c0 .9204.746188 1.6666 1.666668 1.6666H17.4999c.9205 0 1.6667-.7462 1.6667-1.6666V4.99967c0-.92047-.7462-1.66666-1.6667-1.66666ZM.833252 8.33301H19.1666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
